
import LockIcon from './Icons/LockIcon.vue'
import LinkIcon from './Icons/LinkIcon.vue'

export default {
    name: 'LoginRequired',
    components: { LinkIcon, LockIcon },
    inject: [
        'loginPath'
    ]
}
